import { render, staticRenderFns } from "./msCheckbox.vue?vue&type=template&id=243a1b38&scoped=true"
import script from "./msCheckbox.vue?vue&type=script&lang=js"
export * from "./msCheckbox.vue?vue&type=script&lang=js"
import style0 from "./msCheckbox.vue?vue&type=style&index=0&id=243a1b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243a1b38",
  null
  
)

export default component.exports